__turbopack_context__.v({
  "cartCountBadge": "do-54q_cartCountBadge",
  "cartIcon": "do-54q_cartIcon",
});
